module.exports = __webpack_public_path__ + "img/202208.603511a8.png";